import { ChatbotValue } from "../../../services/api/instances/botApi/types";

export const getUpdatedChatbotValue = (
  value: ChatbotValue,
  fields: Partial<ChatbotValue["tg_bot_object"]> = {},
): ChatbotValue => ({
  tg_bot_object: {
    ...value.tg_bot_object,
    ...fields,
  },
});
